export function setConsignmentProductsPreInvoiceData(state, data) {
    state.consignmentProductsPreInvoiceData = data;
}



// WEBPACK FOOTER //
// ./src/modules/consignment-products-pre-Invoice/mutations.js